import { __decorate, __metadata, __param } from "tslib";
import _ from 'lodash';
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let DialogService = class DialogService {
    constructor(i18n) {
        this.i18n = i18n;
        this._dialogFunction = null;
        this._confirmFunction = null;
    }
    success(message, title) {
        message = message || this.i18n.t('backoffice.common.Success');
        title = title || this.i18n.t('backoffice.common.Success');
        this._dialogFunction({
            title,
            message,
            variant: 'success',
        });
    }
    error(message, title) {
        message = message || this.i18n.t('backoffice.common.tips');
        title = title || this.i18n.t('backoffice.common.tips');
        this._dialogFunction({
            title,
            message,
            variant: 'danger',
        });
    }
    confirm(option) {
        option = _.merge({
            confirmButtonText: this.i18n.t('backoffice.common.yes'),
            cancelButtonText: this.i18n.t('backoffice.common.no'),
        }, option);
        return this._confirmFunction(option);
    }
    /**
     * 传入一个处理函数，这里相当于做一个统一处理
     * @param fn
     */
    registerDialogFunction(fn) {
        this._dialogFunction = fn;
    }
    registerConfigmFunction(fn) {
        this._confirmFunction = fn;
    }
};
DialogService = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object])
], DialogService);
export { DialogService };
